import styled from "styled-components";

export const AddButtonContainer = styled.button`
  display: grid;
  place-content: center;
  border-radius: 12px;
  border: 1px dashed ${({ theme }) => theme.border.black15};
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.bg.secondary};
  cursor: pointer;
  color: ${({ theme }) => theme.text.text};
  min-height: 256px;
`;
